<template>
<div class="container">
  <div class="page-loader-wrapper" v-if="inProgress" style="position: absolute; transform: translate(-50%, -50%); left: 50%; top: 50%">
    <b-spinner></b-spinner>
  </div>
  <b-alert v-else-if="notFound" variant="warning" show>
    <strong>Produkt nicht gefunden.</strong> Es wurde möglicherweise gelöscht.
    <b-link to="/products">Zurück zu den Produkten</b-link>
  </b-alert>
  <div v-else>
    <product-description :product="product" @description-updated="updateProductDescription"></product-description>
    <ProductTags></ProductTags>
    <ProductCollection :product-collections="product.collections"></ProductCollection>
    <tax-rates :collections="collections" @tax-changed="getProduct"></tax-rates>
    <ProductImages :images="product.images" :alt-default="product.title"></ProductImages>
    <ProductVariants :product="product"></ProductVariants>
  <div>
      <VariantInventory :variants="product.variants"></VariantInventory>
  </div>
  </div>
</div>
</template>

<script>
import "firebase/auth";
import products from "@/api/products";
import ProductImages from "@/pages/EditProductPage/ProductImages";
import ProductCollection from "@/pages/EditProductPage/ProductCollection";
import ProductDescription from "@/components/ProductDescription";
import ProductTags from "@/pages/EditProductPage/ProductTags";
import ProductVariants from "@/pages/EditProductPage/Variants/ProductVariants";
import VariantInventory from "@/pages/EditProductPage/Variants/VariantInventory";
import TaxRates from "@/pages/EditProductPage/TaxRates";
import {handleError} from "@/utils/errors";
import {mapState} from "vuex";


export default {
  data() {
    return {
      user: null,
      isNotNew: true,
      inProgress: true,
      notFound: false
    }
  },
  components: {
    TaxRates,
    ProductTags,
    ProductDescription,
    ProductCollection,
    ProductImages,
    ProductVariants,
    VariantInventory
  },
  computed: {
    ...mapState(
        'products',
        {
          tags: state => state.product.tags || []
        }
    ),
    product: {
      get () {
          return this.$store.state.products.product
      },
      set (value) {
          this.$store.commit('products/setProduct', value)
      }
    },
    taxRateCollection(){
      return this.collections.find(collection => collection.title.startsWith('tax_'))
    },
    collections(){
      return this.product.collections || []
    },
    images(){
      return this.product.images || []
    }
  },
  methods: {
    checkInput(e) {
      console.log(this.product, e)
    },
    saveVariant(variantId) {
      products.putVariant(variantId, this.product.variants[0])
    },
    getProduct(){
      products.getProduct(this.$route.params.id).then(
          product => {
            this.product = product
          }).finally(() => this.inProgress = false);
    },
    updateProductDescription(updatedDescriptions){
      this.product = {...this.product, ...updatedDescriptions}
    }
  },
  async created() {
    try {
      await this.$store.dispatch("products/fetchProduct", {productId: this.$route.params.id})
    } catch (error) {
      if (error.response && error.response.status === 404) {
        this.notFound = true
        this.inProgress = false
        this.$store.commit('products/removeProduct', this.$route.params.id)
      } else {
        // Keep the loader: the store may still hold a different product.
        handleError({vm: this, error})
      }
      return
    }
    sessionStorage.setItem(this.$route.params.id, JSON.stringify(this.product))
    if (this.$route.query.changed) {
      this.isNotNew = false
    }
    this.inProgress = false
  },
  async beforeRouteLeave(n, o, next) {
    if (n.hash === '#deleted' || this.notFound) {
      return next()
    }
    const pId =  o.params.id
    const hasNoChanged = sessionStorage.getItem(JSON.parse(pId)) === JSON.stringify(this.product)
    if (!hasNoChanged || !this.isNotNew) {
      try {
        await this.$store.dispatch('products/fetchProduct', {productId: pId, isUpdated: true})
      } catch (e) {
        console.log("Failed to update product before leaving the page")
      }
    }
    return next()
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

